/** The parts of MyWunderland an office computer can be allowed to open besides the Schedule (owner 11/4; server/src/modules.ts). */
export const MODULES: { key: string; name: string; sub: string }[] = [
  { key: 'reports', name: 'Reports', sub: 'Daily paperwork, weekly totals, history' },
];
